export const CapeeshSizes = {
    CreatorSideBar: '200px',
}

Object.freeze(CapeeshSizes)
